import { create } from 'zustand'

export const useIdeStore = create((set, get) => ({
  currentProject: null,
  fileTree: [],
  openFiles: [],
  activeFilePath: null,
  aiMessages: [],
  terminalHistory: [],
  recentProjects: [],
  usageSnapshot: null,
  upgradePrompt: null,
  setRecentProjects(recentProjects) {
    set({ recentProjects })
  },
  setProject(project) {
    set({
      currentProject: project,
      fileTree: project?.tree || [],
      recentProjects: get().recentProjects,
    })
  },
  setUsageSnapshot(usageSnapshot) {
    set({ usageSnapshot })
  },
  setUpgradePrompt(upgradePrompt) {
    set({ upgradePrompt })
  },
  appendTerminalEntry(entry) {
    set(state => ({ terminalHistory: [...state.terminalHistory, entry] }))
  },
  appendAiMessage(message) {
    set(state => ({ aiMessages: [...state.aiMessages, message] }))
  },
  openFile(file) {
    set(state => {
      const existing = state.openFiles.find(item => item.path === file.path)
      if (existing) {
        return { activeFilePath: file.path }
      }
      return {
        openFiles: [...state.openFiles, file],
        activeFilePath: file.path,
      }
    })
  },
  updateFileContents(filePath, contents) {
    set(state => ({
      openFiles: state.openFiles.map(file =>
        file.path === filePath ? { ...file, contents, dirty: true } : file
      ),
    }))
  },
  markFileSaved(filePath) {
    set(state => ({
      openFiles: state.openFiles.map(file =>
        file.path === filePath ? { ...file, dirty: false } : file
      ),
    }))
  },
  closeFile(filePath) {
    set(state => {
      const nextOpenFiles = state.openFiles.filter(file => file.path !== filePath)
      return {
        openFiles: nextOpenFiles,
        activeFilePath:
          state.activeFilePath === filePath
            ? nextOpenFiles.at(-1)?.path || null
            : state.activeFilePath,
      }
    })
  },
  setActiveFile(filePath) {
    set({ activeFilePath: filePath })
  },
}))
